export default "__VITE_ASSET__Bnt8zn0n__"